import { MDBIcon, MDBInput, MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import React, { Component } from 'react';
import { ProductosSimula_, CargueImagenes, TiposProductos_, ClasificacionProductos_, TipoCuenta_, ProductosConfiguracion_ } from '../../../services/WebAPI_Utrahuilca';
import FileUploaderB from './Producto/FileUploaderB';
import Swal from 'sweetalert2';
import { URLImgFront } from '../../../config/URLDB';
import { MDBModal, MDBModalHeader, MDBModalBody } from 'mdbreact';

const validate = values => {
    const errors = {}
    if (values.prolinea === 'DEFAULT') {
        errors.prolinea = 'campo obligatorio'
    }

    if (!values.nombprodutra) {
        errors.nombprodutra = 'campo obligatorio'
    }

    if (values.idtipoprod === 'DEFAULT') {
        errors.idtipoprod = 'campo obligatorio'
    }

    if (values.idtipopers === 'DEFAULT') {
        errors.idtipopers = 'campo obligatorio'
    }

    if (!values.descprodutra) {
        errors.descprodutra = 'campo obligatorio'
    }

    if (values.idtipocuenta === 'DEFAULT') {
        errors.idtipocuenta = 'campo obligatorio'
    }

    if (values.idclasificacionprodutos === 'DEFAULT') {
        errors.idclasificacionprodutos = 'campo obligatorio'
    }

    if (values.idnuevoproducto === 'DEFAULT') {
        errors.idnuevoproducto = 'campo obligatorio'
    }

    if (!values.fechanuevoprodu) {
        errors.fechanuevoprodu = 'campo obligatorio'
    }

    if (values.cambioEstadoVista === 'DEFAULT') {
        errors.cambioEstadoVista = 'campo obligatorio'
    }

    if (!values.rutaproddet) {
        errors.rutaproddet = 'campo obligatorio'
    }

    return errors;
};


const validateConfig = values => {
    const errorsConfig = {}
    
    if (!values.tituloconfig) {
        errorsConfig.tituloconfig = 'campo obligatorio'
    }

    if (!values.descripcionconfig) {
        errorsConfig.descripcionconfig = 'campo obligatorio'
    }

    return errorsConfig;
};

class Producto extends Component {
    //RQTO. CDAT Y AHORRO DIGITAL, REAJUSTE YC
    uploader = React.createRef();
    uploaderB = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            estadoNuevo: false,
            errors: {},
            errorsConfig: {},
            infoProductos: [],
            estado: null,
            idprodutra: null,
            nombprodutra: '',
            descprodutra: '',
            rutaimgprod: '',
            rutavistaprod: '',
            prolinea: 'DEFAULT',
            idtipoprod: 'DEFAULT',
            idtipopers: 'DEFAULT',
            estadoCambioImg: true,
            estadoEditar: false,
            estadoCambio: false,
            estadoSinResultados: false,
            infoProductosUtraW: [],
            infoClasificacionProductos: [],
            infoTipoCuenta: [],
            idtipocuenta: 'DEFAULT',
            idclasificacionprodutos: 'DEFAULT',
            idnuevoproducto: 'DEFAULT',
            fechanuevoprodu: "1900-01-01",
            fechanuevoproduHabilitado: false,
            boolrutaproddet: true,
            cambioEstadoVista: 'DEFAULT',
            rutaproddet: '',
            booidtipocuenta: true,
            idSeleccionado: 1,
            informacionConfiguracion: [],
            caracteristicas: [],
            beneficios: [],
            requisitos: [],
            preguntas: [],
            tips: [],
            cargueItems: false,
            idproducto: 0,
            booliconoconfig: true
        };
    }

    componentDidMount() {
        this.cargarInformacion();
    }

    cargarInformacion = () => {
        const data = {
            tran: 4,
            idprodutra: 0,
            nombprodutra: 'NA',
            descprodutra: 'NA',
            rutaimgprod: 'NA',
            rutavistaprod: 'NA',
            prolinea: 0,
            idtipoprod: 0,
            idtipopers: 0,
            estado: 1,
            usucrea: 'NA',
            idtipocuenta: 0,
            prodnuevo: 0,
            idclasificprod: 0,
            fecnuevohasta: "",
            rutaproddet: 0
        }

        ProductosSimula_(data).then(response => {
            try {
                if (response.data.length > 0) {
                    if (response.data.length >= 1) {
                        if (response.data[0].message === "004404") {
                            this.setState({
                                estadoSinResultados: false
                            })
                        } else {
                            this.setState({
                                infoProductos: response.data,
                                idprodutra: response.data[0].idprodutra,
                                rutaiconobenef: response.data[0].rutaiconobenef,
                                descbenef: response.data[0].descbenef,
                                estado: response.data[0].estado,
                                estadoSinResultados: true
                            })
                        }
                    } else {
                        this.setState({
                            estadoSinResultados: false
                        })
                    }
                } else {
                    this.setState({
                        estadoNuevo: true
                    })
                }
            } catch (error) {
                console.log(error);
            }
        });

        this.cargarTipoCuenta();
        this.cargarClasificiacionProducto();
    }

    cargarImagen = () => {
        var formData = new FormData();
        if (undefined === this.uploader.current) return;
        
        formData.append("file", this.uploader.current.getFileObject());
        formData.append("rutaImagen", '/Productos/' + this.uploader.current.getFileName());
        CargueImagenes(formData).then(response => {
            if (response) {
                this.cargarInformacion();
            }
        });
    }

    cargarImagenConfiguracion = () => {
        var formData = new FormData();
        if (undefined === this.uploaderB.current) return;

        formData.append("file", this.uploaderB.current.getFileObject());
        formData.append("rutaImagen", '/Productos/' + this.uploaderB.current.getFileName());
        CargueImagenes(formData).then(response => {
            if (response) {
                this.cargarInformacionConfiguracion(this.state.idproducto, this.state.idSeleccionado);
            }
        });
    }

    textInput = (e) => {
        if (e.target.name === "idtipoprod") {
            this.cargarProductos(e.target.value);
            this.setState({ idtipocuenta: "DEFAULT", booidtipocuenta: false });
            //AQUI VALIDO SI ES CREDITO PARA DEJAR EL TIPO DE CUENTA EN NORMAL
            if (e.target.value == "2") {
                this.setState({ idtipocuenta: "1", booidtipocuenta: true });
            }
        }

        if (e.target.name === "idnuevoproducto") {
            if (e.target.value === "1") {
                this.setState({
                    fechanuevoprodu: '',
                    fechanuevoproduHabilitado: true

                });
            } else {
                this.setState({
                    fechanuevoprodu: '1900-01-01',
                    fechanuevoproduHabilitado: false

                });
            }
        }

        if (e.target.name === "cambioEstadoVista") {
            if (e.target.value === "1") {
                this.setState({
                    boolrutaproddet: true,
                    rutaproddet: 'NA'
                })
            } else if (e.target.value === "2") {
                this.setState({
                    boolrutaproddet: false,
                    rutaproddet: ''
                })
            }
        }

        this.setState({
            [e.target.name]: e.target.value
        })
    }

    cargarProductos = (id) => {
        TiposProductos_({ id_cuenta: parseInt(id) }).then(response => {
            try {
                if (response.data.length > 0) {
                    if (response.data[0].respuesta) {
                        Swal.fire({
                            icon: 'success',
                            title: 'No se logró cargar los productos a enlazar'
                        });
                    } else {
                        this.setState({
                            infoProductosUtraW: response.data
                        })
                    }
                } else { }
            } catch (error) {
                console.log(error);
            }
        });
    }

    cargarTipoCuenta = () => {
        TipoCuenta_({ tran: 4, idtipocuenta: 0, nombcuenta: "N/A", desccuenta: "N/A", estado: 1 }).then(response => {
            try {
                if (response.data.length > 0) {
                    if (response.data[0].respuesta) {
                        Swal.fire({
                            icon: 'success',
                            title: 'No se logró cargar los tipos de cuenta'
                        });
                    } else {
                        this.setState({
                            infoTipoCuenta: response.data
                        })
                    }
                } else { }
            } catch (error) {
                console.log(error);
            }
        });
    }

    cargarClasificiacionProducto = () => {
        ClasificacionProductos_({ tran: 4, idclasificprod: 0, descripcion: "N/A", estado: 1 }).then(response => {
            try {
                if (response.data.length > 0) {
                    if (response.data[0].respuesta) {
                        Swal.fire({
                            icon: 'success',
                            title: 'No se logró cargar la clasificación de productos'
                        });
                    } else {
                        this.setState({
                            infoClasificacionProductos: response.data
                        })
                    }
                } else { }
            } catch (error) {
                console.log(error);
            }
        });
    }

    cambioImagen = (name, file) => {
        this.setState({
            estadoCambioImg: true
        });
    }

    cambioImagenConfiguracion = (name, file) => {
        this.setState({
            booliconoconfig: true
        });
    }

    editar = (id) => {
        var seleccionado = [];
        this.state.infoProductos.map((e, i) => {
            if (e.idprodutra === id) {
                seleccionado.push(e)
            }
            return [];
        })
        this.cargarProductos(seleccionado[0].idtipoprod);
        this.setState({
            idprodutra: seleccionado[0].idprodutra,
            prolinea: seleccionado[0].prolinea,
            nombprodutra: seleccionado[0].nombprodutra,
            idtipoprod: seleccionado[0].idtipoprod,
            idtipopers: seleccionado[0].idtipopers,
            descprodutra: seleccionado[0].descprodutra,
            rutaimgprod: seleccionado[0].rutaimgprod,
            estadoEditar: true
        });
    }

    cambio = (name, file) => {
        this.setState({
            estadoCambio: true
        });
    }

    activar = (id) => {
        const data = {
            tran: 9,
            idprodutra: id,
            nombprodutra: 'NA',
            descprodutra: 'NA',
            rutaimgprod: 'NA',
            rutavistaprod: 'NA',
            prolinea: 0,
            idtipoprod: 0,
            idtipopers: 0,
            estado: 1,
            usucrea: sessionStorage.getItem('idusuario'),
            idtipocuenta: 0,
            idclasificacionprodutos: 0,
            idnuevoproducto: 0,
            fechanuevoprodu: '1900-01-01',
            rutaproddet: 'NA'
        }

        ProductosSimula_(data).then(response => {
            if (response) {
                this.setState({
                    estadoS: false
                })
                Swal.fire({
                    icon: 'success',
                    title: 'Se activo satisfactoriamente'
                });
                this.cargarInformacion();
            }
        });
    }

    inactivar = (id) => {
        const data = {
            tran: 9,
            idprodutra: id,
            nombprodutra: 'NA',
            descprodutra: 'NA',
            rutaimgprod: 'NA',
            rutavistaprod: 'NA',
            prolinea: 0,
            idtipoprod: 0,
            idtipopers: 0,
            estado: 0,
            usucrea: sessionStorage.getItem('idusuario'),
            idtipocuenta: 0,
            idclasificacionprodutos: 0,
            idnuevoproducto: 0,
            fechanuevoprodu: '1900-01-01',
            rutaproddet: 'NA'
        }

        ProductosSimula_(data).then(response => {
            if (response) {
                this.setState({
                    estadoS: false
                })
                Swal.fire({
                    icon: 'success',
                    title: 'Se inactivo satisfactoriamente'
                });
                this.cargarInformacion();
            }
        });
    }

    limpiarInformacionProductos = () => {
        this.setState({
            estadoNuevo: false,
            registroSeleccionado: null,
            errors: {},
            nombprodutra: '',
            descprodutra: '',
            prolinea: 'DEFAULT',
            idtipoprod: 'DEFAULT',
            idtipopers: 'DEFAULT',
            infoProductosUtraW: [],
            idtipocuenta: 'DEFAULT',
            idclasificacionprodutos: 'DEFAULT',
            idnuevoproducto: 'DEFAULT',
            fechanuevoprodu: "1900-01-01",
            fechanuevoproduHabilitado: false,
            cambioEstadoVista: 'DEFAULT',
            rutaproddet: '',
            boolrutaproddet: true,
            estadoCambioImg: true,
            nombreboton: 'Crear',
            booidtipocuenta: false
        });
    }

    TransarDatos = (datos) => {
        const { errors, ...sinErrors } = this.state;
        const result = validate(sinErrors);
        this.setState({ errors: result });

        if (!Object.keys(result).length) {
            //formulario validado
            let letidprodutra = 0;
            var ruta = '';

            if (datos == null) {
                letidprodutra = 0;
                ruta = '/Productos/' + this.uploader.current.getFileName();
            }
            else {
                letidprodutra = datos.idprodutra

                var capNombre = this.uploader.current.getFileName();

                if (capNombre === undefined || capNombre === null) {
                    ruta = this.state.rutaimgprod;
                } else {
                    ruta = '/Productos/' + this.uploader.current.getFileName();
                }
            }
            const data = {
                tran: 1,
                idprodutra: letidprodutra,
                nombprodutra: this.state.nombprodutra.toUpperCase(),
                descprodutra: this.state.descprodutra,
                rutaimgprod: ruta,
                rutavistaprod: 'NA',
                prolinea: parseInt(this.state.prolinea),
                idtipoprod: parseInt(this.state.idtipoprod),
                idtipopers: parseInt(this.state.idtipopers),
                estado: 1,
                usucrea: sessionStorage.getItem('idusuario'),
                idtipocuenta: parseInt(this.state.idtipocuenta),
                idclasificacionprodutos: parseInt(this.state.idclasificacionprodutos),
                idnuevoproducto: parseInt(this.state.idnuevoproducto),
                fechanuevoprodu: this.state.fechanuevoprodu,
                rutaproddet: this.state.rutaproddet
            }
            ProductosSimula_(data).then(response => {
                if (response.data.length > 0) {
                    if (response.data[0].message === "000000") {
                        this.cargarImagen();
                        Swal.fire({
                            icon: 'success',
                            title: letidprodutra === 0 ? 'Se agrego correctamente.' : 'Se actualizo satisfactoriamente'
                        })
                        this.limpiarInformacionProductos();
                        this.cargarInformacion();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: letidprodutra === 0 ? 'Error al insertar.' : 'Error al actualizar'
                        })
                    }
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrio un error!'
                    })
                }
            });
        }
    }

    handleNew = (datos) => {
        //AQUI TEMGO QUE LIMPIAR
        this.limpiarInformacionProductos();
        this.setState({ estadoNuevo: !this.state.estadoNuevo });

        //AQUI VALIDO EN QUE MOMENTO VA INSERTAR O ACTUALIZAR
        if (datos === null) {
            
        }
        else {
            // CONVERTIMOS LA FECHA"
            let fechaFormateada = "";

            if (!datos.fecnuevohasta) {
                // SI VIENE NULL, UNDEFINED O VACÍO, USAMOS 1900-01-01
                fechaFormateada = "1900-01-01";
            } else {
                // CONVERTIMOS AL FORMATO YYYY-MM-DD
                fechaFormateada = new Date(datos.fecnuevohasta)
                    .toISOString()
                    .split("T")[0];
            }
            this.cargarProductos(datos.idtipoprod);
            this.setState({
                registroSeleccionado: datos,
                idprodutra: datos.idprodutra,
                estadoCambioImg: false,
                nombprodutra: datos.nombprodutra,
                prolinea: datos.prolinea,
                idtipopers: datos.idtipopers,
                descprodutra: datos.descprodutra,
                rutaimgprod: datos.rutaimgprod,
                idtipocuenta: datos.idtipocuenta,
                idclasificacionprodutos: datos.idclasificprod,
                idnuevoproducto: datos.prodnuevo,
                fechanuevoprodu: fechaFormateada,
                idtipoprod: datos.idtipoprod,
                fechanuevoproduHabilitado: datos.prodnuevo === 0 ? false : true,
                cambioEstadoVista: datos.rutaproddet === "NA" ? 1 : 2,
                rutaproddet: datos.rutaproddet,
                boolrutaproddet: datos.rutaproddet === "NA" ? true : false,
                nombreboton: 'Editar',
                booidtipocuenta: datos.idtipoprod === 2 ? true : false
            });
        }
    }

    cargarInformacionConfiguracion = (idpro, iditem) => {
        const data = {
            tran: 5,
            idprodutra: idpro,
            descripcion: 'NA',
            manejarutaimg: 0,
            rutaimg: 'NA',
            usucrea: 'NA',
            titulo: 'NA',
            orden: 0,
            iditem: iditem,
            estado: 1,
            idconfigitem: 0
        }
        ProductosConfiguracion_(data).then(response => {
            try {
                if (response.data.length > 0) {
                    if (response.data.length >= 1) {
                        if (response.data[0].message === "004404") {
                            this.setState({
                                cargueItems: false,
                                informacionConfiguracion: []
                            })
                        } else {
                            this.setState({
                                cargueItems: true,
                                informacionConfiguracion: response.data,
                            })
                        }
                    } else {
                        this.setState({
                            cargueItems: false,
                            informacionConfiguracion: []
                        })
                    }
                } else {
                    this.setState({
                        cargueItems: false,
                        informacionConfiguracion: []
                    })
                }
            } catch (error) {
                console.log(error);
            }
        });
    }

    abrirModalConfiguracion = (datos) => {
        this.setState({
            showModalConfig: true,
            titulo: datos.nombprodutra,
            estadoNuevoConfg: false,
            tituloBoton: 'Caracteristicas',
            idSeleccionado: 1,
            idproducto: datos.idprodutra
        });

        //AQUI CARGO LOS ITEMS SEGUN EL PRODUCTO Y LA CARACTERISTICA
        this.cargarInformacionConfiguracion(datos.idprodutra, this.state.idSeleccionado);
    }

    cerrarModalEditar = () => {
        
        this.setState({
            showModalConfig: false,
            estadoNuevoConfg: true,
            idSeleccionado: 1,
            idproducto: 0,
            cargueItems: false,
            informacionConfiguracion: []
        });

        this.limpiarInformacionFormulario();
    };

    limpiarConfiguracion = () => {
        this.setState({
            estadoNuevoConfg: false,
            tituloconfig: '',
            descripcionconfig: '',
            cargueItems: false,
            informacionConfiguracion: []
        })
    }

    busquedaId = (id) => {
        this.limpiarConfiguracion();
        this.setState({
            //est: !this.state.est,
            idSeleccionado: id,
            tituloBoton: this.obtenerTexto(id)
        });

        //AQUI CARGO LOS ITEMS SEGUN EL PRODUCTO Y LA CARACTERISTICA
        this.cargarInformacionConfiguracion(this.state.idproducto, id);
    }

    obtenerTexto(id) {
        switch (id) {
            case 1: return "CARACTERÍSTICAS".toLocaleLowerCase('es-ES');
            case 2: return "BENEFICIOS".toLocaleLowerCase();
            case 3: return "REQUISITOS".toLocaleLowerCase();
            case 4: return "PREGUNTAS FRECUENTES".toLocaleLowerCase();
            case 5: return "TIPS".toLocaleLowerCase();
            default: return "";
        }
    }

    handleNewConfig = (id) => {
        this.setState({ estadoNuevoConfg: !this.state.estadoNuevoConfg });
        this.limpiarInformacionFormulario();
        this.configuracionPrincipalItems();
        if (id === null) {
            this.setState({
                booliconoconfig: true,
                nombrebotonConfig: 'Guardar'
            })
        }
        else {
            this.setState({
                registroSeleccionadoConfig: id,
                tituloconfig: id.titulo,
                descripcionconfig: id.descripcion,
                rutaiconoconfig: id.rutaimg,
                booliconoconfig: false,
                nombrebotonConfig: 'Editar'
            });
        }
    }

    configuracionPrincipalItems = () => {
        this.setState({
            booltituloconfig: this.state.idSeleccionado === 4 || this.state.idSeleccionado === 5 ? false : true,
            tituloconfig: this.state.idSeleccionado === 4 || this.state.idSeleccionado === 5 ? '' : 'N/A'
        });
    }

    limpiarInformacionFormulario = () => {
        this.setState({
            registroSeleccionadoConfig: null,
            booliconoconfig: false,
            rutaiconoconfig: '',
            booltituloconfig: false,
            descripcionconfig: '',
            tituloconfig: ''
        });
    }

    TransarConfiguracionProductos = (datos) => {
        const { errorsConfig, ...sinErrors } = this.state;
        const result = validateConfig(sinErrors);
        this.setState({ errorsConfig: result });

        if (!Object.keys(result).length) {
            let letidprodutra = 0;
            let letidconfigitem = 0;
            var ruta = '';

            if (datos == null) {
                letidprodutra = this.state.idproducto
                letidconfigitem = 0;
                ruta = '/Productos/' + this.uploaderB.current.getFileName();
            }
            else {
                letidprodutra = datos.idprodutra
                letidconfigitem = datos.idconfigitem;
                var capNombre = this.uploaderB.current.getFileName();

                if (capNombre === undefined || capNombre === null) {
                    ruta = this.state.rutaiconoconfig;
                } else {
                    ruta = '/Productos/' + this.uploaderB.current.getFileName();
                }
            }
            
            // formulario validado
            const data = {
                tran: 1,
                idprodutra: letidprodutra,
                descripcion: this.state.descripcionconfig,
                manejarutaimg: 0,
                rutaimg: ruta,
                usucrea: sessionStorage.getItem('idusuario'),
                titulo: this.state.tituloconfig,
                orden: 1,
                iditem: this.state.idSeleccionado,
                estado: 1,
                idconfigitem: letidconfigitem
            }
            ProductosConfiguracion_(data).then(response => {
                if (response.data.length > 0) {
                    if (response.data[0].message === "000000") {
                        this.cargarImagenConfiguracion();
                        Swal.fire({
                            icon: 'success',
                            title: datos === null ? 'Se agrego correctamente.' : 'Se actualizo satisfactoriamente'
                        })
                        this.limpiarInformacionFormulario();
                        this.setState({ estadoNuevoConfg: false });
                        this.configuracionPrincipalItems();

                        //AQUI CARGO LOS ITEMS SEGUN EL PRODUCTO Y LA CARACTERISTICA
                        this.cargarInformacionConfiguracion(letidprodutra, this.state.idSeleccionado);
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: datos === null ? 'Error al insertar.' : 'Error al actualizar'
                        })
                    }
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrio un error!'
                    })
                }
            });
        }
    }

    transarAcciones = (operacion, datos) => {
        let valorestado;
         //AQUI VALIDO SI DEBO DE INACTIVA
        if (operacion === 1) {
            valorestado = 0; 
        }
        else {
            valorestado = 1;
        }

        const data = {
            tran: 7,
            idprodutra: datos.idprodutra,
            descripcion: 'NA',
            manejarutaimg: 0,
            rutaimg: 'NA',
            usucrea: sessionStorage.getItem('idusuario'),
            titulo: 'NA',
            orden: 1,
            iditem: datos.iditem,
            estado: valorestado,
            idconfigitem: datos.idconfigitem
        }
        ProductosConfiguracion_(data).then(response => {
            if (response.data.length > 0) {
                if (response.data[0].message === "000000") {
                    Swal.fire({
                        icon: 'success',
                        title: operacion === 1 ? 'Se ha inactivado correctamente.' : 'Se activado correctamente.'
                    })

                    //AQUI CARGO LOS ITEMS SEGUN EL PRODUCTO Y LA CARACTERISTICA
                    this.cargarInformacionConfiguracion(datos.idprodutra, datos.iditem);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: operacion === 1 ? 'Error al inactivar.' : 'Error al activar'
                    })
                }
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Ocurrio un error!'
                })
            }
        });
    }

    render() {
        const { estadoNuevo, errors, errorsConfig, infoProductos, estadoSinResultados } = this.state;
        return (
            <React.Fragment>
                <p className="font-weight-bold">Productos</p>
                <hr />
                <div className="plus_add_agencia align-items-center d-flex" onClick={() => { this.handleNew(null) }}>
                    {estadoNuevo ? <p>Cancelar &nbsp;<MDBIcon icon="times" size="lg" /></p> : <p>Crear Producto &nbsp;<MDBIcon icon="plus-circle" size="lg" /></p>}
                </div>
                {estadoNuevo ? (
                    <React.Fragment>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 my-3 text-center">
                                    <FileUploaderB ref={this.uploader} estadoImg={this.state.estadoCambioImg} ruta={this.state.rutaimgprod} FCambiar={this.cambioImagen} />
                                </div>
                                <div className="col-md-6 my-2">
                                    <label>Tipo de Producto</label>
                                    <select name="idtipoprod" className="form-control" value={this.state.idtipoprod} onChange={this.textInput}>
                                        <option value="DEFAULT" disabled>Seleccione...</option>
                                        <option value="1">Ahorro</option>
                                        <option value="2">Crédito</option>
                                    </select>
                                    {errors.idtipoprod && <strong className="text-danger" style={{ fontSize: '13px' }}>{errors.idtipoprod}</strong>}
                                </div>
                                <div className="col-md-6 my-2">
                                    <label>Prolinea (UTRAWEB)</label>
                                    <select name="prolinea" className="form-control" value={this.state.prolinea} onChange={this.textInput}>
                                        <option value="DEFAULT" disabled>Seleccione...</option>

                                        {this.state.infoProductosUtraW &&
                                            this.state.infoProductosUtraW.map((e, i) => {
                                                return [
                                                    <React.Fragment key={i}>
                                                        <option value={e.codprolinea}>{e.descprolinea}</option>
                                                    </React.Fragment>
                                                ]
                                            })
                                        }
                                    </select>

                                    {errors.prolinea && <strong className="text-danger" style={{ fontSize: '13px' }}>{errors.prolinea}</strong>}
                                </div>
                                <div className="col-md-6 my-2">
                                    <label>Tipo de Persona</label>
                                    <select name="idtipopers" className="form-control" value={this.state.idtipopers} onChange={this.textInput}>
                                        <option value="DEFAULT" disabled>Seleccione...</option>
                                        <option value="1">Natural</option>
                                        <option value="0">Jurídica</option>
                                    </select>
                                    {errors.idtipopers && <strong className="text-danger" style={{ fontSize: '13px' }}>{errors.idtipopers}</strong>}
                                </div>
                                <div className="col-md-6 my-2">
                                    <label>Nombre del Producto</label>
                                    <MDBInput label="Digite el nombre producto" name="nombprodutra" type="text" value={this.state.nombprodutra} onChange={this.textInput} />
                                    {errors.nombprodutra && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '80px' }}>{errors.nombprodutra}</strong>}
                                </div>
                                <div className="col-md-3 my-2">
                                    <label>Tipo Cuenta</label>
                                    <select name="idtipocuenta" className="form-control" value={this.state.idtipocuenta} disabled={this.state.booidtipocuenta} onChange={this.textInput}>
                                        <option value="DEFAULT" disabled>Seleccione...</option>
                                        {this.state.infoTipoCuenta &&
                                            this.state.infoTipoCuenta.map((e, i) => {
                                                return [
                                                    <React.Fragment key={i}>
                                                        <option value={e.idtipocuenta}>{e.nombcuenta}</option>
                                                    </React.Fragment>
                                                ]
                                            })
                                        }
                                    </select>
                                    {errors.idtipocuenta && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '80px' }}>{errors.idtipocuenta}</strong>}
                                </div>
                                <div className="col-md-3 my-2">
                                    <label>Clasificación del Producto</label>
                                    <select name="idclasificacionprodutos" className="form-control" value={this.state.idclasificacionprodutos} onChange={this.textInput}>
                                        <option value="DEFAULT" disabled>Seleccione...</option>
                                        {this.state.infoClasificacionProductos &&
                                            this.state.infoClasificacionProductos.map((e, i) => {
                                                return [
                                                    <React.Fragment key={i}>
                                                        <option value={e.idclasificprod}>{e.descripcion}</option>
                                                    </React.Fragment>
                                                ]
                                            })
                                        }
                                    </select>
                                    {errors.idclasificacionprodutos && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '80px' }}>{errors.idclasificacionprodutos}</strong>}
                                </div>
                                <div className="col-md-3 my-2">
                                    <label>Nuevo Producto</label>
                                    <select name="idnuevoproducto" className="form-control" value={this.state.idnuevoproducto} onChange={this.textInput}>
                                        <option value="DEFAULT" disabled>Seleccione...</option>
                                        <option value="1">SI</option>
                                        <option value="0">NO</option>
                                    </select>
                                    {errors.idnuevoproducto && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '80px' }}>{errors.idnuevoproducto}</strong>}
                                </div>
                                <div className="col-md-3 my-2">
                                    <label>Fecha Nuevo Producto</label>
                                    <MDBInput name="fechanuevoprodu" type="date" value={this.state.fechanuevoprodu} disabled={!this.state.fechanuevoproduHabilitado} onChange={this.textInput} />
                                    {errors.fechanuevoprodu && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '80px' }}>{errors.fechanuevoprodu}</strong>}
                                </div>
                                <div className="col-md-6 my-2">
                                    <label>¿Qué Tipo de Vista Desea?</label>
                                    <select name="cambioEstadoVista" className="form-control" value={this.state.cambioEstadoVista} onChange={this.textInput}>
                                        <option value="DEFAULT" disabled>Seleccione...</option>
                                        <option value="1">Generica</option>
                                        <option value="2">Establecida</option>
                                    </select>
                                    {errors.cambioEstadoVista && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '80px' }}>{errors.cambioEstadoVista}</strong>}
                                </div>
                                <div className="col-md-6 my-2">
                                    <label>Descripción de la Vista</label>
                                    <MDBInput name="rutaproddet" type="text" disabled={this.state.boolrutaproddet} value={this.state.rutaproddet} onChange={this.textInput} />
                                    {errors.rutaproddet && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '80px' }}>{errors.rutaproddet}</strong>}
                                </div>
                                <div className="col-md-12 mt-3">
                                    <label>Descripción</label>
                                    <MDBInput name="descprodutra" type="textarea" rows="5" value={this.state.descprodutra} onChange={this.textInput} />
                                    {errors.descprodutra && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', marginTop: '-30px' }}>{errors.descprodutra}</strong>}
                                </div>
                            </div>
                        </div>
                        <div className="pt-2 mt-5 modal-footer w-100">                            
                            <button type="button" className="btn btn-primary px-5" onClick={() => this.TransarDatos(this.state.registroSeleccionado)}>{this.state.nombreboton} Producto &nbsp; <MDBIcon icon="save" /></button>
                        </div>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <div className="container-fluid">
                            <div className="table-responsive text-center w-100">
                                <MDBTable>
                                    <MDBTableHead>
                                        <tr className="font-weight-bold">
                                            <td>Imagen</td>
                                            <td>Nombre Producto</td>
                                            <td>Tipo de Producto</td>
                                            <td>ProLinea</td>
                                            <td>Tipo de Persona</td>
                                            <td>Descripción</td>
                                            <td>Editar</td>
                                            <td>Inactivar</td>
                                            <td>Configuración</td>
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                        {estadoSinResultados ? (
                                            <React.Fragment>
                                            {
                                                (
                                                    <React.Fragment>
                                                        {infoProductos.map((e, i) => {
                                                            let view;
                                                            let tp;
                                                            let pers;
                                                            if (e.estado === 1) {
                                                                view = <MDBIcon onClick={() => { this.inactivar(e.idprodutra) }} icon="eye" size="2x" style={{ cursor: 'pointer' }} />
                                                            } else {
                                                                view = <MDBIcon onClick={() => { this.activar(e.idprodutra) }} icon="eye-slash" size="2x" style={{ cursor: 'pointer' }} />
                                                            }
                                                            if (e.idtipoprod === 1) {
                                                                tp = 'Ahorro'
                                                            } else {
                                                                tp = 'Crédito'
                                                            }
                                                            if (e.idtipopers === 1) {
                                                                pers = 'Natural'
                                                            } else {
                                                                pers = 'Jurídica'
                                                            }
                                                            return [
                                                                <React.Fragment key={i}>
                                                                    <tr>
                                                                        <td><img width="150" src={`${URLImgFront}/assets${e.rutaimgprod}`} alt={e.rutaimgprod} /></td>
                                                                        <td>{e.nombprodutra}</td>
                                                                        <td>{tp}</td>
                                                                        <td>{e.prolinea}</td>
                                                                        <td>{pers}</td>
                                                                        <td>{e.descprodutra}</td>
                                                                        {/*<td className="text-center" onClick={() => { this.editar(e.idprodutra) }}><MDBIcon icon="edit" size="2x" style={{ color: 'green', cursor: 'pointer' }} /></td>*/}
                                                                        <td className="text-center">
                                                                            <MDBIcon icon="edit" size="2x" style={{ color: 'green', cursor: 'pointer' }} onClick={() => this.handleNew(e)} />
                                                                        </td>
                                                                        <td className="text-center">{view}</td>
                                                                        <td className="text-center">
                                                                            <MDBIcon onClick={() => { this.abrirModalConfiguracion(e) }} className="text-center" icon="bars" size="2x" style={{ color: 'orange', cursor: 'pointer' }} />   
                                                                        </td>
                                                                    </tr>
                                                                </React.Fragment>
                                                            ]
                                                        })}
                                                    </React.Fragment>
                                                )}
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>
                                                <tr className="alert alert-info text-center w-100">
                                                    <td>Sin resultados</td>
                                                </tr>
                                            </React.Fragment>
                                        )}
                                    </MDBTableBody>
                                </MDBTable>
                            </div>
                        </div>
                    </React.Fragment>
                )}

                <MDBModal isOpen={this.state.showModalConfig} toggle={this.cerrarModalEditar} size="xl" className="bg-white">
                    <MDBModalHeader toggle={this.cerrarModalEditar}>
                        CONFIGURACIÓN PRODUCTO {this.state.titulo}
                    </MDBModalHeader>
                    <MDBModalBody style={{ height: "100%" }}>
                        <div className="row">
                            <div className="col-md-3" style={{ height: "200px" }}>
                                <div className="listado_banner">
                                    <ul>
                                        {[1, 2, 3, 4, 5].map((id) => (
                                            <li
                                                key={id}
                                                id={id}
                                                onClick={() => this.busquedaId(id)}
                                                style={
                                                    this.state.idSeleccionado === id
                                                        ? { background: '#f47216', cursor: 'pointer', color: '#fff', fontWeight: 'bold' }
                                                        : { background: '#fff', cursor: 'pointer', color: '#000', fontWeight: 'normal' }
                                                }
                                            >
                                                {this.obtenerTexto(id)}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-9">
                                <div className="plus_add_agencia align-items-center d-flex" onClick={() => { this.handleNewConfig(null) }}>
                                    {this.state.estadoNuevoConfg ? <p>Cancelar &nbsp;<MDBIcon icon="times" size="lg" /></p> : <p>Crear {this.state.tituloBoton} &nbsp;<MDBIcon icon="plus-circle" size="lg" /></p>}
                                </div>
                                <br />
                                <div className="w-100">
                                    {this.state.estadoNuevoConfg ? (
                                        <React.Fragment>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label>Icono</label>
                                                    <div className="text-center">
                                                        <FileUploaderB ref={this.uploaderB} estadoImg={this.state.booliconoconfig} ruta={this.state.rutaiconoconfig} FCambiar={this.cambioImagenConfiguracion} />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <MDBInput label="Digite el titulo" name="tituloconfig" disabled={this.state.booltituloconfig} type="text" value={this.state.tituloconfig} onChange={this.textInput} />
                                                    {errorsConfig.tituloconfig && <strong className="text-danger" style={{ fontSize: '13px' }}>{errorsConfig.tituloconfig}</strong>}
                                                </div>
                                                <div className="col-md-12">
                                                    <MDBInput label="Digite la descripción" name="descripcionconfig" type="textarea" rows="4" value={this.state.descripcionconfig} onChange={this.textInput} />
                                                    {errorsConfig.descripcionconfig && <strong className="text-danger" style={{ fontSize: '13px' }}>{errorsConfig.descripcionconfig}</strong>}
                                                </div>
                                            </div>
                                            <div className="pt-2 mt-5 modal-footer w-100">
                                                <button type="button" className="btn btn-primary px-5" onClick={() => this.TransarConfiguracionProductos(this.state.registroSeleccionadoConfig)}>{this.state.nombrebotonConfig} Configuración &nbsp; <MDBIcon icon="save" /></button>
                                            </div>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            <div className="w-100">
                                                {this.state.cargueItems ? (
                                                    <div className="table-responsive text-center w-100">
                                                        <MDBTable>
                                                            <MDBTableHead>
                                                                <tr className="font-weight-bold">
                                                                    <td>Icono</td>
                                                                    <td>Título</td>
                                                                    <td>Descripción</td>
                                                                    <td>Editar</td>
                                                                    <td>Acciones</td>
                                                                </tr>
                                                            </MDBTableHead>
                                                            <MDBTableBody>
                                                                <React.Fragment>
                                                                    {this.state.informacionConfiguracion.map((e, i) => {
                                                                        let view;
                                                                        if (e.estado === 1) {
                                                                            view = <MDBIcon onClick={() => { this.transarAcciones(1, e) }} icon="eye" size="2x" style={{ cursor: 'pointer', color: 'orange' }} />
                                                                        } else {
                                                                            view = <MDBIcon onClick={() => { this.transarAcciones(2, e) }} icon="eye-slash" size="2x" style={{ cursor: 'pointer', color: '#333' }} />
                                                                        }
                                                                        return [
                                                                            <React.Fragment key={i}>
                                                                                <tr>
                                                                                    <td><img width="30" src={`${URLImgFront}/assets${e.rutaimg}`} alt={e.rutaimg} /></td>
                                                                                    <td className="text-justify">{e.titulo}</td>
                                                                                    <td className="text-justify">{e.descripcion}</td>
                                                                                    <td className="text-center"><MDBIcon onClick={() => { this.handleNewConfig(e) }} className="text-center" icon="edit" size="2x" style={{ color: 'green', cursor: 'pointer' }} />   </td>
                                                                                    <td>
                                                                                        {view}
                                                                                    </td>
                                                                                </tr>
                                                                            </React.Fragment>
                                                                        ]
                                                                    })}
                                                                </React.Fragment>
                                                            </MDBTableBody>
                                                        </MDBTable>
                                                    </div>
                                                ) : (
                                                    <React.Fragment>
                                                        <div className="alert alert-info text-center w-100 mt-3 mt-lg-3">
                                                            <p>Sin resultados</p>
                                                        </div>
                                                    </React.Fragment>
                                                )}
                                            </div>
                                        </React.Fragment>
                                    )}
                                </div>
                            </div>
                        </div>
                    </MDBModalBody>
                </MDBModal>
            </React.Fragment>
        );
    }
}

export default Producto;